import { render, staticRenderFns } from "./RemindersList.vue?vue&type=template&id=7a2ce005"
import script from "./RemindersList.vue?vue&type=script&lang=js"
export * from "./RemindersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports